import { Input, ViewChild, TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Gallery, GalleryItem, ThumbnailsPosition, ImageSize, GalleryModule, ImageItem  } from 'ng-gallery';//from "@ngx-gallery/core";
import { Lightbox }  from 'ng-gallery/lightbox';//from "@ngx-gallery/lightbox";
import { LightboxModule } from 'ng-gallery/lightbox';
import { AveriasService } from '../servicios/averias.service';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { NbDialogRef } from '@nebular/theme';
import { report } from 'process';
import { flatMap } from 'lodash';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
 import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
 import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
//import {SharedModule} from '../shared/shared.module';
import { NbSelectModule } from '@nebular/theme';
import { NbOptionModule } from '@nebular/theme';
import { GalleryState } from 'ng-gallery';
import { Observable } from 'rxjs';


@Component({
    selector: 'app-edit-averia',
    templateUrl: './edit-averia.component.html',
    styleUrls: ['./edit-averia.component.css'],
    standalone: true,
    imports: [SpinnerComponent, FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,
      NbSelectModule, NbOptionModule,
      GalleryModule,
      LightboxModule 
    ],
})
export class EditAveriaComponent implements OnInit {
  @Input() public detalle: any;
  @Input() public tipoReporte: any;
  public actualizar: boolean;
  @ViewChild('itemTemplate') itemTemplate: TemplateRef<any>;

  galleryState: Observable<GalleryState>;

  durationInSeconds = 3;
  items: GalleryItem[];
  indexFoto = 0;
  idFoto = 0;
  imageData = fotosDefault;
  showSpinnerFotos: boolean = true;
  SeveridadSeleccionada;
  tipoAveriaSeleccionada;
  areaComponenteSeleccionada;
  responsablesSeleccionada;
  zonaCuadranteDetalleSeleccionada;
  clasificacionSeleccionada;
  severidad = [];
  tipoAveria = [];
  areaComponente = [];
  responsables = [];
  zonaCuadranteDetalle = [];
  clasificacion = [];
  tipoResponsable: boolean = false;
  editar = false;
  habilitarGuardarCambios = false;
  deshabilitarSolucionar = false;
  severidadesLoaded = false;
  tipoAveriasLoaded = false;
  responsablesLoaded = false;
  clasificacionLoaded = false;
  zonaCuadDetallesLoaded = false;
  cargo = false;
  infoPopup;
  idCliente;
  comentarioAveria;
  showSpinnerGuardar: boolean = false;
  myConfig = {
    btnContainerClass: '',            // The CSS class(es) to be applied to the button container
    btnClass: 'default',              // The CSS class(es) that will be applied to the buttons e.g. default is needed for FontAwesome icons, while not needed for Material Icons
    btnSubClass: 'material-icons',    // The CSS class(es) that will be applied to span elements inside material buttons (a Elements)
    zoomFactor: 0.1,                  // The amount that the scale will be increased by
    containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
    wheelZoom: true,                  // If true, the mouse wheel can be used to zoom in
    allowFullscreen: false,            // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: true,    // If true, the left / right arrow keys can be used for navigation
    btnShow: {                        // Control which icons should be visible                
      zoomIn: false,
      zoomOut: false,
      rotateClockwise: false,
      rotateCounterClockwise: false,
      next: false,
      prev: false,
      reset: false
    },
    btnIcons: {                       // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: {
        classes: 'fa fa-plus',        // this property will be used for FontAwesome and other libraries to set the icons via the classes - choose one: classes or text
        text: 'zoom_in'               // this property will be used for Material-Icons and similar libraries to set the icons via the text
      },
      zoomOut: {
        classes: 'fa fa-minus',
        text: 'zoom_out'
      },
      rotateClockwise: {
        classes: 'fa fa-repeat',
        text: 'rotate_right'
      },
      rotateCounterClockwise: {
        classes: 'fa fa-undo',
        text: 'rotate_left'
      },
      next: {
        classes: 'fa fa-arrow-right',
        text: 'arrow_right'
      },
      prev: {
        classes: 'fa fa-arrow-left',
        text: 'arrow_left'
      },
      fullscreen: {
        classes: 'fa fa-arrows-alt',
        text: 'fullscreen'
      },
      reset: {
        classes: 'fa fa-undo',
        text: 'restore'
      }
    }
  };

  // 
  procesoSelecionado: String = '';
  cedenteSelecionado: String = '';
  receptorSelecionado: String = '';
  procesos;
  // 
  isComentarioEdicion = null

  selectedImage : string = '';

  constructor(public lightbox: Lightbox, private servicioAverias: AveriasService,
    public gallery: Gallery, private _snackBar: MatSnackBar,
    public usersRol: PerfilesUsuarioService, public dialogRef: NbDialogRef<EditAveriaComponent>
  ) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.consultarDetalle();
    this.actualizar = false;
  }

  consultarDetalle() {
    let idAveria = { idVinAveria: this.detalle };
    let idVinInspeccionAveria = { idVinInspeccionAveria: this.detalle };
    let reporte = this.tipoReporte;
    this.showSpinnerFotos = true;
    this.deshabilitarEdicion();

    //esto es para mostrar el tipo de responsable y ocultar el responsable cuando el reporte es 11 o 12
    if (reporte == 11 || reporte == 12) {
      this.tipoResponsable = true;
    }
    else {
      this.tipoResponsable = false
    }

    if (reporte == 7 || reporte == 8 || reporte == 11 || reporte == 12) {
      this.servicioAverias.getDetalleInspeccionAveria(idVinInspeccionAveria).subscribe(data => {
        this.infoPopup = data;
        this.comentarioAveria = this.infoPopup.comentarioModificacion
        this.cargarDropDowns();
        this.imageData = this.infoPopup.fotosAveria.length > 0 ? this.infoPopup.fotosAveria : 2;
        this.mapeoFotos();
        this.showSpinnerFotos = false;
      })
    }
    else {
      this.servicioAverias.getDetalleAveria(idAveria).subscribe(data => {
        this.infoPopup = data;
        this.comentarioAveria = this.infoPopup.comentarioModificacion
        this.cargarDropDowns();
        this.imageData = this.infoPopup.fotosAveria.length > 0 ? this.infoPopup.fotosAveria : 2;
        this.mapeoFotos();
        this.showSpinnerFotos = false;
      });
    }
  }
  mapeoFotos() {
    if (this.infoPopup.fotosAveria.length > 0) {
      this.imageData = [];
      this.infoPopup.fotosAveria.forEach(element => {
        this.imageData.push({
          id: element.id,
          src: 'data:image/png;base64,' + element.foto,
          thumb: 'data:image/png;base64,' + element.foto
        })
      });
    }


     this.selectedImage = this.imageData[0].src;



    // Creat gallery items  
    // this.items = this.imageData.map(item => {
    //   return {
    //     type: "imageViewer",
    //     data: {
    //       src: item.src,
    //       thumb: item.thumb
    //     }
    //   };
    // });

    this.items = this.imageData.map(img => new ImageItem({ src: img.src, thumb: img.thumb }));

    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref("lightbox");
    this.galleryState = lightboxRef.state;

    // Add custom gallery config to the lightbox (optional)
    // lightboxRef.setConfig({
    //   imageSize: ImageSize.Cover,
    //   thumbPosition: ThumbnailsPosition.Top,
    //   itemTemplate: this.itemTemplate,
    //   //gestures: false
    // });

    // Load items into the lightbox gallery ref
    lightboxRef.load(this.items);
  }

  
//GALLERYA MANUAL ****************************************************

//  selectedImage = this.imageData[0].src;

    selectedIndex = 0;
    get selectedImageData() {
      return this.imageData[this.selectedIndex].src;
    }

    lightboxOpen = false;
    zoom = 1;
    readonly zoomStep = 0.1;
    readonly zoomMin = 1;
    readonly zoomMax = 3;

    // Arrastre
    isDragging = false;
    startX = 0;
    startY = 0;
    currentX = 0;
    currentY = 0;

    selectImageByIndex(index: number) {
      this.selectedIndex = index;
      this.resetZoomAndPosition();
    }

    selectImage(src: string) {
      const index = this.imageData.findIndex(i => i.src === src);
      if (index !== -1) this.selectImageByIndex(index);
    }

    openLightbox() {
      this.lightboxOpen = true;
      this.resetZoomAndPosition();
    }

    closeLightbox() {
      this.lightboxOpen = false;
      this.resetZoomAndPosition();
    }

    resetZoomAndPosition() {
      this.zoom = 1;
      this.currentX = 0;
      this.currentY = 0;
    }

    onWheel(event: WheelEvent) {
      event.preventDefault();

      if (event.deltaY < 0) {
        this.zoom = Math.min(this.zoom + this.zoomStep, this.zoomMax);
      } else {
        this.zoom = Math.max(this.zoom - this.zoomStep, this.zoomMin);
      }

      if (this.zoom <= 1) {
        this.currentX = 0;
        this.currentY = 0;
      }
    }

    onMouseDown(event: MouseEvent) {
      if (this.zoom <= 1) return;
      this.isDragging = true;
      this.startX = event.clientX - this.currentX;
      this.startY = event.clientY - this.currentY;
    }

    onMouseMove(event: MouseEvent) {
      if (!this.isDragging) return;
      this.currentX = event.clientX - this.startX;
      this.currentY = event.clientY - this.startY;
      // Limitar movimiento si quieres aquí
    }

    onMouseUp() {
      this.isDragging = false;
    }

    onMouseLeave() {
      this.isDragging = false;
    }

    // Navegación
    prevImage() {
      if (this.selectedIndex > 0) {
        this.selectImageByIndex(this.selectedIndex - 1);
      }
    }

    nextImage() {
      if (this.selectedIndex < this.imageData.length -1) {
        this.selectImageByIndex(this.selectedIndex + 1);
      }
    }

  // END GALLERYA MANUAL ****************************************************


  cargarDropDowns() {
    this.servicioAverias.getTipo(this.idCliente).subscribe(data => {
      this.insertarTipo(data);
    })
    this.servicioAverias.getSeveridad(this.idCliente).subscribe(data => {
      this.insertarSeveridad(data);
    })
    this.servicioAverias.getZonaCuadranteDetallePorAreaComponente(this.infoPopup.idAreaComponente).subscribe(data => {
      this.insertarZonaCuadranteDetalle(data);
    })
    this.servicioAverias.getOperadoresPorCliente(this.idCliente).subscribe(data => {
      this.insertarResponsables(data);
    })
    this.servicioAverias.getClasificacion(this.idCliente).subscribe(data => {
      this.insertarClasificacion(data);
    })
    this.insertarProcesos()
  }
  insertarTipo(armarTipo) {
    armarTipo.content.forEach(element => {
      this.tipoAveria.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.tipoAveriaSeleccionada = this.infoPopup.idTipoAveria;
    this.tipoAveriasLoaded = true;
  };
  //Severidad
  insertarSeveridad(armarSeveridad) {
    armarSeveridad.content.forEach(element => {
      this.severidad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.SeveridadSeleccionada = this.infoPopup.idSeveridad;
    this.severidadesLoaded = true;
  };
  insertarZonaCuadranteDetalle(armarZonaCuadranteDetalle) {
    armarZonaCuadranteDetalle.forEach(element => {
      this.zonaCuadranteDetalle.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.zonaCuadranteDetalleSeleccionada = this.infoPopup.idZonaCuadranteDetalle;
    this.zonaCuadDetallesLoaded = true;
  };
  insertarResponsables(armarResponsables) {
    armarResponsables.forEach(element => {
      this.responsables.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.responsablesSeleccionada = this.infoPopup.idResponsable;
    this.receptorSelecionado = this.infoPopup.idReceptor;
    this.cedenteSelecionado = this.infoPopup.idCedente;
    this.responsablesLoaded = true;
  };
  insertarClasificacion(armarClasificacion) {
    armarClasificacion.content.forEach(element => {
      this.clasificacion.push({
        label: element.descripcion,
        value: element.id
      });
    })
    this.clasificacionSeleccionada = this.infoPopup.idClasificacion;
    this.clasificacionLoaded = true;
  }
  // Procesos
  insertarProcesos() {
    this.procesos = [
      { label: 'Importacion', value: 1 },
      { label: 'Exportacion', value: 2 },
      { label: 'Mercado Interno', value: 3 },
    ]
    this.procesoSelecionado = this.infoPopup.idProceso
  }
  // 
  habilitarEdicion() {
    this.editar = true;
    this.habilitarGuardarCambios = true;
    this.deshabilitarSolucionar = true;
  }
  deshabilitarEdicion() {
    this.editar = false;
    this.habilitarGuardarCambios = false;
    this.deshabilitarSolucionar = false;
    this.isComentarioEdicion = null;
  }
  saveEdicion() {
    if (!this.comentarioAveria) {
      this.isComentarioEdicion = false
      return
    } else {
      this.isComentarioEdicion = true
    }
    let guardar = [
      {
        idVinAveria: this.detalle,
        idZonaCuadranteDetalle: this.zonaCuadranteDetalleSeleccionada,
        idTipoAveria: this.tipoAveriaSeleccionada,
        idSeveridad: this.SeveridadSeleccionada,
        idResponsable: this.responsablesSeleccionada,
        idClasificacion: this.clasificacionSeleccionada,
        comentarioModificacion: this.comentarioAveria,
        idProceso: this.procesoSelecionado,
        idCedente: this.cedenteSelecionado,
        idReceptor: this.receptorSelecionado,
      }
    ];
    this.showSpinnerGuardar = true;
    this.servicioAverias.editDetalleAveria(guardar).subscribe(data => {
      if (data.status == 200) {
        this.actualizar = true;
        this.consultarDetalle();
        alert("Registro modificado correctamente.");
        this.showSpinnerGuardar = false;
      } else if (data.status == 500) {
        alert("Ocurrio un error al modificar los datos.");
        this.actualizar = false;
        this.consultarDetalle();
        this.showSpinnerGuardar = false;
      }
      else {
        alert("Ocurrio un error al modificar los datos.");
        this.actualizar = false;
        this.consultarDetalle();
        this.showSpinnerGuardar = false;
      }
      this.showSpinnerGuardar = false;
    }, error => {
      alert("Ocurrio un error al modificar los datos.");
      this.actualizar = false;
      this.consultarDetalle();
      this.showSpinnerGuardar = false;
    })
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  closeDialog() {
    this.dialogRef.close(this.actualizar)
  }
  desahabilitarEditar() {
    this.editar = false
  }
  styleTextArea() {
    return { 'width': '90%', 'border': this.isComentarioEdicion === false ? '1px solid red' : '' }
  }

}

var fotosDefault = [
  {
    id: 0,
    src: "assets/img/no_disponible.jpg",
    thumb: "assets/img/no_disponible.jpg"
  }
];
